import {
  FlexibleBlockBrickText,
  FlexibleBlockProps,
  FlexibleBlockTemplateText,
  PortalTextType,
} from '@nx-frontend/shared/types';
import { getWrapperProps } from '@nx-frontend/shared/utils/blocks';

export const getTextBlockTemplate = (): FlexibleBlockProps<FlexibleBlockTemplateText>[] => {
  let brickIndex = -1;

  const brickCommon = {
    index: 0,
    enabled: true,
    sortable: true,
    removable: true,
    switchable: true,
  };

  const brickText: FlexibleBlockBrickText = {
    ...brickCommon,
    brickType: 'text',
    brickName: 'Text',
    text: 'Your journey starts here! Add your unique message to engage your audience.',
    placeholder: 'Description text',
    className: ['p-0', 'text-base'],
    theme: { text: { main: PortalTextType.SURFACE } },
    index: ++brickIndex,
  };

  return [
    {
      title: 'Simple text',
      wrapper: { ...getWrapperProps('blank'), showTitle: false },
      template: {
        type: 'text',
        view: 'basic',
      },
      bricks: [brickText],
      className: ['gap-4'],
    },
  ];
};
